// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d72417b80aaa29c3","1116":"50ffa24dd2bce457","2931":"1d3afd6fd06bac47","4199":"66d2310b4583aef6","4316":"890f6f4190c9fdfb","8743":"a6f1966981819cfc"}[chunkId] + ".js";
};